import ClientHome from "../../components/ClientHome/ClientHome";
import Menu from "../../components/Menu/Menu";

function GaldermaHome({ userId }) {

    const menuItems = [
        {
          name: "Home",
          link: "/",
        },
        {
          name: "Dashboard",
          link: "/dashboard",
        },
        {
          name: "Data Catalogue",
          link: "/data-catalogue",
        },
      ];
  return (
    <>
      <Menu selectedTab={"Home"} menuItems={menuItems} />
      <ClientHome userId={userId} />
    </>
  );
}
export default GaldermaHome;
